import { AddProfessionalModal } from '@modules/admin/component/add-professional-modal/AddProfessionalModal';
import LoginSignUpModal from '~/modules/user/component/login-signup-modal/LoginSignUpModal';
import { ClientOnly } from 'remix-utils';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
    uiStateAtomLoginModalAuthSource,
    uiStateAtomLoginModalOpened,
    uiStateAtomLoginModalRedirect,
    uiStateAtomLoginModalTitle,
} from '~/modules-rocco/root/states/ui-state-login-modal-opened';
import { uiStateAtomAddProfessionalModalOpened } from '~/modules-rocco/root/states/ui-state-add-professional-modal-opened';

const SiteWideModals = () => {
    const [loginModalOpened, setLoginModalOpened] = useAtom(
        uiStateAtomLoginModalOpened
    );
    const title = useAtomValue(uiStateAtomLoginModalTitle);
    const authSource = useAtomValue(uiStateAtomLoginModalAuthSource);
    const [addProfessionalModalOpened, setAddProfessionalModalOpened] = useAtom(
        uiStateAtomAddProfessionalModalOpened
    );
    const redirect = useAtomValue(uiStateAtomLoginModalRedirect);
    const setLoginModalRedirect = useSetAtom(uiStateAtomLoginModalRedirect);
    const closeLoginModal = () => {
        setLoginModalOpened(false);
        setLoginModalRedirect(undefined);
    };

    return (
        <ClientOnly fallback={''}>
            {() => (
                <>
                    {addProfessionalModalOpened && (
                        <AddProfessionalModal
                            onClose={() => setAddProfessionalModalOpened(false)}
                            isOpen={addProfessionalModalOpened}
                        />
                    )}
                    {loginModalOpened && (
                        <LoginSignUpModal
                            login={{
                                open: true,
                                onCancel: closeLoginModal,
                                onConfirm: closeLoginModal,
                                onAuthSuccess: closeLoginModal,
                                flow: null,
                                authSource: authSource || 'unknown',
                                redirect: redirect,
                                header: title,
                            }}
                            forgotPassword={{
                                open: true,
                                onCancel: closeLoginModal,
                            }}
                        />
                    )}
                </>
            )}
        </ClientOnly>
    );
};

export default SiteWideModals;
